module.exports = __webpack_public_path__ + "img/luntan.42654973.jpg";